@if (!shouldHide()) {
  <ion-list-header class="header">
    {{ title() }}
  </ion-list-header>
  <ion-list>
    @if (!isLoading()) {
      <ion-grid class="grid">
        <ion-row class="row">
          <ng-content></ng-content>
        </ion-row>
      </ion-grid>
    } @else {
      <div class="skeleton-loading">
        <ion-skeleton-text [animated]="true"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true"></ion-skeleton-text>
      </div>
    }
  </ion-list>
}
